import React from 'react';
import { Note } from '../../../../../../../../entities/ApplicationFeed';
import { NoteText } from '../../../../../../../../components/NoteText';
import { longFormatDate } from '../../../../../../../../utils/timeFormat';
import { ATS_MAX_NOTE_LENGTH } from '../../../../../../../../components/ApplicantTracking/NoteModal/ModalBody';

interface PropTypes {
  note: Note;
}

export function NoteEntry(props: PropTypes) {
  return (
    <div className='mb-4'>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <span className='fw-bold text-dark-500 fs-5'>
          {props.note.authorName ?? 'Unknown'}
        </span>
        <span className='text-muted fs-6'>
          {longFormatDate(props.note.createdAt)}
        </span>
      </div>
      <div className='rounded-4 bg-gray py-2 px-3'>
        <NoteText
          text={props.note.note}
          className='text-dark-500'
          maxTextLength={ATS_MAX_NOTE_LENGTH}
          mentionClassName='text-info'
          mentionTransformer={(mention) => `@${mention}`}
        />
      </div>
    </div>
  );
}
